<template>
  <div v-if="!!readonly" class="space-y-2 py-5">
    <ui-link
      v-for="element in computedHeadingsAfterToc"
      :key="element.id"
      :to="'~#'+element.id"
      class="block !no-underline text-slate-400 hover:text-slate-700"
      :class="{
        'font-bold text-lg text-slate-500': element.meta.headline_type == 'h2',
        'font-normal text-md text-slate-500 pl-4': element.meta.headline_type == 'h3',
        'font-normal text-md text-slate-500 pl-6': element.meta.headline_type == 'h4',
        'font-normal text-md text-slate-500 pl-8': element.meta.headline_type == 'h5',
      }"
      :text="element.meta?.i18n?.[locale as SupportedLanguages]?.content ?? element.content"
      svg="fa fa-hashtag"
      iconleft
      />
  </div>
  <blog-content-edit-wrapper v-else-if="model && !$props.readonly" v-model="model"/>
</template>

<script setup lang="ts">
defineProps<{ readonly?: boolean }>()

const model = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')

const router = useRouter()

const { locale } = useI18n()

onMounted(() => {
  const hash = router.currentRoute.value.hash

  if(hash) {
    const element = modelBlog.value?.elements?.find((e) => e.id === hash.slice(1))
    if(element) {
      document.getElementById(element.id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }
})

const computedHeadingsAfterToc = computed(() => {
  if(!modelBlog.value || !modelBlog.value.elements) return []

  const r = JSON.parse(JSON.stringify(modelBlog.value.elements)).filter((element: any) => {
    const t = element.type?.toLowerCase()
    return t === 'heading'
      || t === 'title'
      || t === 'subheading'
      || t === 'subsubheading'
  })

  return r;
})
</script>
